export const INS_MONTH = 'ins_month' as const;
export const ONE_WAY_NO_PRICE = 'OneWayNone' as const;
export const PREVIOUS_CURRENCY = 'qp_prevCurrency' as const;
export const PREVIOUS_PRICE = 'qp_prevPrice' as const;
export const PREVIOUS_PROVIDER = 'qp_prevProvider' as const;
export const PRICE_SOURCE_ID = 'priceSourceId' as const;
export const PRICE_TRACE = 'priceTrace' as const;
export const RETURN_NO_PRICE = 'ReturnNoPrices' as const;

export const CAR_HIRE_PROVIDER_LOGO_BASE_URL =
  'https://logos.skyscnr.com/images/carhire/vendors' as const;

export const urlConstants = {
  INS_MONTH,
  ONE_WAY_NO_PRICE,
  PREVIOUS_CURRENCY,
  PREVIOUS_PRICE,
  PREVIOUS_PROVIDER,
  PRICE_SOURCE_ID,
  PRICE_TRACE,
  RETURN_NO_PRICE,
} as const;

export default urlConstants;
